module.exports = __webpack_public_path__ + "img/weih1.10a927a7.png";